import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const contractRouters: RouteRecordRaw[] = [
    {
        path: "/storeContract",
        name: "StoreContract",
        meta: {
            title: "合同管理",
            isNotShowHeader: true,
            activeMenu: "StoreContract",
            pageType: PAGE_TYPE.LIST.code,
            keepAlive: true
        },
        component: () => import("@/views/pages/warehouseManagement/contractManagement/index.vue")
    },
    {
        path: "/storeContract/contractDetail",
        name: "StoreContractDetail",
        meta: { title: "合同详情", hidden: true, activeMenu: "StoreContract", pageType: PAGE_TYPE.DETAIL.code },
        component: () => import("@/views/pages/warehouseManagement/contractManagement/detail.vue")
    }
];

export default contractRouters;
